import { createEntityFilterStore } from "./createEntityFilterStore";
import type { ContractFilters } from "@/domain/types";

const initialFilters: ContractFilters = {
	search: "",
	status: "",
	contract_type: "",
	document_uuid: "",
	sort: { key: undefined, direction: null },
};

export const useContractFiltersStore = createEntityFilterStore<ContractFilters>(
	"ContractFiltersStore",
	initialFilters,
);
